<ic-auth-wrapper>
	<ic-confirm-password-form [loading]="loading" (authenticate)="onAuthenticate($event)" />
</ic-auth-wrapper>
